import { render } from "./tnc.vue?vue&type=template&id=71b4efec&scoped=true"
import script from "./tnc.vue?vue&type=script&lang=js"
export * from "./tnc.vue?vue&type=script&lang=js"

import "./tnc.vue?vue&type=style&index=0&id=71b4efec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b4efec"]])

export default __exports__